var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApplication = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "data-coloringtype": "fill",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.9,
  d: "M16.206 2.005A4 4 0 0 1 20 6v3.94l2.47-2.47 1.06 1.06L15.06 17H13l-.03-.03 5.53-5.53V6A2.5 2.5 0 0 0 16 3.5H8A2.5 2.5 0 0 0 5.5 6v12A2.5 2.5 0 0 0 8 20.5h8a2.5 2.5 0 0 0 2.5-2.5v-2.94l1.5-1.5V18a4 4 0 0 1-4 4H8a4 4 0 0 1-3.995-3.794L4 18V6a4 4 0 0 1 4-4h8zM12 17H8v-1.5h4zm1.5-4.25H8v-1.5h5.5zM16 8.5H8V7h8z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgApplication;